import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.module.scss";

function IconNotification({ notificationText }) {
    if (!notificationText) {
        return null;
    }

    return (
        <div className={ styles.iconNotification }>
            { notificationText }
        </div>
    );
}

IconNotification.propTypes = {
    notificationText: PropTypes.string
};

export default IconNotification;
